import { CategoryCodeInfo } from '@app-types/plan';

import { PlanTypeId } from '@constants/plan';

import { EligibilityOffer } from './eligibility-offer';

export function sortOffersWithCategoryOrder(
    categories: CategoryCodeInfo[],
    offers: EligibilityOffer[] = [],
): EligibilityOffer[] {
    const result: EligibilityOffer[] = [];

    categories.forEach((categoryCodeInfo) => {
        const offer = offers.find((offer) => {
            return (
                offer.rangeNg === categoryCodeInfo.rangeNg &&
                offer.commercialSeries === categoryCodeInfo.commercialSeries &&
                offer.technology === categoryCodeInfo.technology
            );
        });

        if (offer) {
            result.push(offer);
        }
    });

    return result;
}

type EligibilityCategories = PlanTypeId.FAI_BIG | PlanTypeId.FAI_5GBOX | PlanTypeId.FAI_PUREBYOU;

type OffersByCategory<T extends PlanTypeId> = {
    [key in T]: {
        hasHat: boolean;
        offers: EligibilityOffer[];
    };
};

export function getOffersByCategories(
    offers: EligibilityOffer[],
    categoriesCodes: CategoryCodeInfo[],
    shortListOffer?: EligibilityOffer,
): OffersByCategory<EligibilityCategories> {
    const categories: OffersByCategory<EligibilityCategories> = {
        [PlanTypeId.FAI_BIG]: { hasHat: false, offers: [] },
        [PlanTypeId.FAI_5GBOX]: { hasHat: false, offers: [] },
        [PlanTypeId.FAI_PUREBYOU]: { hasHat: false, offers: [] },
    };

    offers.forEach((offer) => {
        if (offer.isHidden || offer.sku === shortListOffer?.sku) return;
        offer.categories.forEach((category) => {
            if (Object.keys(categories).includes(category)) {
                const key = category as EligibilityCategories;
                categories[key].offers.push(offer);
                if (offer.hat) categories[key].hasHat = true;
            }
        });
    });

    Object.keys(categories).forEach((categoryKey) => {
        const key = categoryKey as keyof typeof categories;
        categories[key]!.offers = sortOffersWithCategoryOrder(categoriesCodes, categories[key]!.offers);
    });

    return categories;
}
